import * as React from 'react';

import { useSettingsLocation } from '@rematter/modules/settings/_state/settingsModule.state';
import { cn } from '@rematter/ui-web';

import { SettingsPath } from '../../routes';

export const SettingsLink = ({
  href,
  className,
  ...props
}: Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: SettingsPath;
}) => {
  const [, setLocation] = useSettingsLocation();

  return (
    <a
      {...props}
      className={cn('@SettingsLink', className)}
      href={href as never}
      onClick={(e) => {
        e.preventDefault();
        setLocation(href as SettingsPath);
        props.onClick?.(e);
      }}
    />
  );
};
